import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { tokenNotExpired } from 'angular2-jwt';
import { Observable } from 'rxjs/Rx';

import { AuthHttp, JwtHelper } from 'angular2-jwt';

// SERVICES
import { EventsService } from 'app/services/events';

// INTERFACES
import { Usuario } from 'app/interfaces';

@Injectable()
export class AuthService {
  private c: string = 'YWRtaW46OWtjMVE1dkU1WmYwcE1Od0lvZXV5OGxvVmJBPQ==';
  // private baseUrlAuth = 'https://ws1.paranamodapark.com.br:65435';
  private baseUrlAuth = 'https://pmp.rlimainfo.com.br:65438';
  // private baseUrlAuth = 'http://10.101.0.99:65438';
  private evento: any;
  constructor(
    private http: Http,
    private aHttp: AuthHttp,
    private events: EventsService,
  ) {
    this.evento = events.getEvento();
  }

  addToken(accessToken: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      try {
        localStorage.setItem('token', accessToken);
        return (resolve(true));
      } catch (error) {
        throw reject(error);
      }
    });
  }

  getToken(toRefresh?): Promise<string> {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem('token');
      if (!toRefresh && !tokenNotExpired(undefined, token)) {
        this.refreshToken().toPromise().then((resposta) => {
          return resolve(localStorage.getItem('token'));
        });
      } else {
        return resolve(token);
      }
    });
  }

  getBaseUrl() {
    return this.baseUrlAuth;
  }

  getCode() {
    return this.c;
  }

  getTokenData() {
    return this.getToken().then(token => {
      if (token) {
        const jwt = new JwtHelper();
        return jwt.decodeToken(token);
      } else {
        throw { erro: 'Erro na consulta do token' };
      }
    });
  }

  loggedIn(): Observable<boolean> {
    return new Observable(observer => {
      this.getToken().then(token => {
        if (tokenNotExpired('token', token)) {
          // tslint:disable-next-line:no-console
          console.log('pode ir');
          observer.next(true);
          return observer.complete();
        } else {
          // tslint:disable-next-line:no-console
          console.log('nao pode ir');
          this.refreshToken().subscribe(resposta => {
            observer.next(resposta);
            return observer.complete();
          });
        }
      });
    });
  }

  refreshToken(): Observable<boolean> {
    return new Observable(observer => {
      this.getToken(true).then(token => {
        if (!token) {
          // tslint:disable-next-line:no-console
          console.log('sem token!');
          observer.next(false);
          return observer.complete();
        }
        const headers = new Headers();
        headers.append('Cache-Control', 'no-cache');
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        // tslint:disable-next-line:prefer-template
        headers.append('Authorization', 'Bearer ' + token);

        // tslint:disable-next-line:prefer-template
        this.http.get(this.baseUrlAuth + '/users/refreshToken', { headers })
          .timeout(120000)
          .map(resposta => resposta.json())
          .subscribe(resposta => {
            this.addToken(resposta.token).then(success => {
              // tslint:disable-next-line:no-console
              console.log('agora pode ir');
              observer.next(true);
              return observer.complete();
            });
          }, error => {
            // tslint:disable-next-line:no-console
            console.log('sem refresh!', error);
            observer.next(false);
            return observer.complete();
          });
      });
    });
  }

  login(dados, cadastro?): Promise<any> {
    const headers = new Headers();
    headers.append('Cache-Control', 'no-cache');
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    // tslint:disable-next-line:prefer-template
    headers.append('Authorization', 'Basic ' + this.getCode());

    // tslint:disable-next-line:prefer-template
    const consulta = this.http.post(this.baseUrlAuth + '/users/login',
      JSON.stringify(dados),
      {
        headers,
      });

    this.evento.emit({ tipo: 'loader:show' });
    return new Promise((resolve, reject) => {
      consulta.subscribe(data => {
        const resposta: any = data.json();
        this.addToken(resposta.token).then(sucesso => {
          this.dadosLogin().then(retorno => {
            localStorage.setItem('avatar', retorno.avatar);
            this.evento.emit({ tipo: 'user:login' });
            resolve(true);
          }).catch((erro) => {
            // tslint:disable-next-line:no-console
            console.log(erro);
            this.evento.emit({ tipo: 'loader:hide' });
            alert('Erro processando os dados do usuário!');
            reject(false);
          });
        });
      }, (error) => {
        this.evento.emit({ tipo: 'loader:hide' });
        if (error.status === 401) {
          if (cadastro) {
            reject(dados);
          } else {
            alert('Credenciais Inválidas');
            reject(false);
          }
        } else {
          alert('Erro de conexão com o servidor!');
          reject(false);
        }
      });
    });
  }

  dadosLogin(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.loggedIn().toPromise().then((logado) => {
        if (logado) {
          // tslint:disable-next-line:prefer-template
          this.aHttp.get(this.baseUrlAuth + '/users/userData')
            .catch((error) => {
              return this.refreshToken().concatMap((resposta) => {
                // tslint:disable-next-line:prefer-template
                return this.aHttp.get(this.baseUrlAuth + '/users/userData');
              });
            }).timeout(120000)
            .map(resposta => resposta.json())
            .toPromise()
            .then((dados) => {
              if (dados === null) {
                this.evento.emit({ tipo: 'user:logout' });
              } else {
                resolve(dados);
              }
            }).catch((erro) => {
              reject(erro);
            });
        } else {
          reject(false);
        }
      });
    });
  }

  permissoes(): Promise<Usuario> {
    return new Promise((resolve, reject) => {
      this.loggedIn().toPromise().then((logado) => {
        if (logado) {
          this.evento.emit({ tipo: 'loader:show' });
          // tslint:disable-next-line:prefer-template
          this.aHttp.get(this.baseUrlAuth + '/users/permissoes')
            .catch((error) => {
              return this.refreshToken().concatMap((resposta) => {
                // tslint:disable-next-line:prefer-template
                return this.aHttp.get(this.baseUrlAuth + '/users/permissoes');
              });
            }).timeout(120000)
            .map((resposta) => {
              this.evento.emit({ tipo: 'loader:hide' });
              return resposta.json();
            })
            .toPromise()
            .then((dados) => {
              if (dados === null) {
                this.evento.emit({ tipo: 'user:logout' });
              } else {
                resolve(dados);
              }
            }).catch((erro) => {
              reject(erro);
            });
        } else {
          reject(false);
        }
      });
    });
  }

  logout() {
    return new Promise((resolve, reject) => {
      try {
        localStorage.clear();
        return (resolve(true));
      } catch (error) {
        throw reject(error);
      }
    });
  }
}



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/services/auth/auth.service.ts